import React, { ReactNode } from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { ConfirmationDialog } from '../../../legacy-design-system/modal'

interface DeleteDialogProps extends RenderDialogProps {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly onConfirm: () => void
  readonly renderTitle: () => ReactNode
  readonly renderBody: () => ReactNode
}

export function ConfirmDeleteRouteDialog({
  isOpen,
  closeDialog,
  onConfirm,
  renderTitle,
  renderBody
}: DeleteDialogProps) {
  return (
    <ConfirmationDialog
      size="small"
      isOpen={isOpen}
      onCancel={closeDialog}
      onConfirm={() => {
        onConfirm()
        closeDialog()
      }}
      renderConfirmMessage={() => <FormattedMessage id="action_delete" />}
      renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
      renderTitle={renderTitle}
      renderBody={() => (
        <React.Fragment>
          <div
            className={css`
              margin-bottom: 15px;
            `}
          >
            {renderBody()}
          </div>
        </React.Fragment>
      )}
    />
  )
}
